export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./breadcrumbs.vue?vue&type=template&id=7ea0463a"


//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumbs.vue?vue&type=template&id=7ea0463a
// module id = AHjJ
// module chunks = 0